(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var sels = ['.shopify-section:not(.hero-wrapper)', '.section-resource-list__header'];
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.closest('.hero-wrapper') && !el.classList.contains('metme-stagger'))
          el.classList.add('metme-reveal');
      });
    });
    document.querySelectorAll('.resource-list--grid').forEach(function (grid) {
      grid.classList.add('metme-stagger');
      grid.classList.remove('metme-reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -32px 0px' });
    document.querySelectorAll('.metme-reveal, .metme-stagger').forEach(function (el) { io.observe(el); });
  }

  function initImageFade() {
    function applyFade(img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('metme-img-loaded'); }
      else {
        img.addEventListener('load', function () { img.classList.add('metme-img-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('metme-img-loaded'); }, { once: true });
      }
    }
    document.querySelectorAll('img[loading="lazy"]').forEach(applyFade);
    var mo = new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          (n.querySelectorAll ? n.querySelectorAll('img[loading="lazy"]') : []).forEach(applyFade);
          if (n.tagName === 'IMG' && n.getAttribute('loading') === 'lazy') applyFade(n);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function init() { initReveal(); initImageFade(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();